import { render, staticRenderFns } from "./role-layout.vue?vue&type=template&id=6971e3a5&scoped=true&"
import script from "./role-layout.vue?vue&type=script&lang=js&"
export * from "./role-layout.vue?vue&type=script&lang=js&"
import style0 from "./role-layout.vue?vue&type=style&index=0&id=6971e3a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6971e3a5",
  null
  
)

export default component.exports